(async () => {
    const { Core } = await importModule('Core');
    const { Plyr } = await importModule('Plyr');

    customElements.define('background-video', class extends Core {

        elements = {
            embeddedPlayer: '[data-player]',
            HTML5Player: 'video'
        }
        
        // LCP OPTIMIZATION: Defer video initialization
        render() {
            if (!this.manualInit) {
                // Defer video initialization to avoid impacting LCP
                if (document.readyState === 'complete') {
                    this._deferredInit();
                } else {
                    window.addEventListener('load', () => this._deferredInit(), { once: true });
                }
            }
        }
        
        _deferredInit() {
            // Use requestIdleCallback if available to initialize the player
            // during browser idle time after the critical content is rendered
            if ('requestIdleCallback' in window) {
                requestIdleCallback(() => this.initPlayer());
            } else {
                setTimeout(() => this.initPlayer(), 100);
            }
        }

        initPlayer() {
            if (this.desktopOnly && document.documentElement.clientWidth <= 992) {
                this.remove();
                return;
            }
            this.player = new Plyr(this.$player, {
                muted: true,
                controls: false,
                clickToPlay: false,
                fullscreen: false
            });
            this.player.on('ended', () => {
                this.player.restart();
            })
            this.player.on('ready', () => {
                this.player.play();
                this.player.decreaseVolume(100);
            })
            // Lazily create and start observing after LCP is complete
            this._lazyObserver = this._getIntersectionObserver();
            this._lazyObserver.observe(this);
        }

        _observer([ entry ]) {
            entry.isIntersecting ? this.player?.play() : this.player?.pause();
        }

        pause() {
            this.player?.pause();
        }

        play() {
            this.player?.play();
        }

        // Create the observer only when needed, not on initial load
        _getIntersectionObserver() {
            return new IntersectionObserver(this._observer.bind(this));
        }

        get manualInit() {
            return this.hasAttribute('manual-init');
        }

        get desktopOnly() {
            return this.hasAttribute('desktop-only');
        }

        get $player() {
            return this.$embeddedPlayer || this.$HTML5Player
        }
    })
})();